import { render, staticRenderFns } from "./SampleItem.vue?vue&type=template&id=7d2ac274&scoped=true&"
import script from "./SampleItem.vue?vue&type=script&lang=js&"
export * from "./SampleItem.vue?vue&type=script&lang=js&"
import style0 from "./SampleItem.vue?vue&type=style&index=0&id=7d2ac274&scoped=true&lang=css&"
import style1 from "./SampleItem.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d2ac274",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VBtn,VForm,VIcon,VList,VListItem,VListItemContent,VListItemTitle,VMenu,VTextarea})
